import { api } from './api'

const enhancedApi = api.enhanceEndpoints({
  addTagTypes: [
    'partner',
  ],
})

const extendedApi = enhancedApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchPartners: builder.query({
      query: () => '/admin/partners',
      providesTags: (result) => [{ type: 'partner', id: 'LIST' }],
    }),

    createPartner: builder.mutation({
      query: (params) => ({
        url: '/admin/partners',
        method: 'POST',
        body: params,
      }),
      invalidatesTags: ['partner'],
    }),

    removePartner: builder.mutation({
      query: (partnerId) => ({
        url: `/admin/partners/${partnerId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['partner'],
    }),

    updatePartner: builder.mutation({
      query: ({ partnerId, params, justification }) => ({
        url: `/admin/partners/${partnerId}`,
        method: 'PATCH',
        body: {
          partner: params,
          ...(!!justification && { audit_comment: justification }),
        },
      }),
      invalidatesTags: ['partner'],
    }),
  }),
  addTagTypes: [
    'partner',
  ],
  overrideExisting: false,
})

export const {
  useFetchPartnersQuery,
  useCreatePartnerMutation,
  useRemovePartnerMutation,
  useUpdatePartnerMutation,
} = extendedApi

export const {
  fetchPartners,
} = extendedApi.endpoints
